<div class="introduction-box-wrapper" [ngClass]="{ hidden: hidden() }">
  <div class="box-left">
    <h1>{{ title() | transloco }}</h1>
    <p>{{ description() | transloco }}</p>
    <div class="content-box">
      @if (contentTpl()) {
        <ng-container *ngTemplateOutlet="contentTpl(); context: { $implicit: hidden() }">
        </ng-container>
      }
    </div>
  </div>
  <div class="box-right">
    <img class="icon" [src]="imageSrc()" [alt]="imageAlt()" />
  </div>
  @if (hidable()) {
    <div class="hide-button">
      <app-button
        [matIcon]="hidden() ? 'open_in_full' : 'close_fullscreen'"
        [type]="'icon'"
        [iconPosition]="'center'"
        (click)="buttonHide()"
        (keydown.enter)="$event.stopPropagation()"
        (keyup.space)="$event.stopPropagation()"
      ></app-button>
    </div>
  }
</div>
